<script>
    import {createEventDispatcher} from "svelte";
    import {_} from "svelte-i18n";

    let dispatch = createEventDispatcher();

    export let filter;
    export let selected = false;
    export let dense = false;
    export let showCross = false;
</script>

<div
        class="headline-xs button"
        class:selected
        class:dense
        on:click={() => dispatch("click", filter.id)}
        style="cursor: pointer;"
>
    {#if showCross && selected}
        <div class="leading">
            <img src="/images/icons/x.svg" alt={$_("delete_filters_alt")}/>
        </div>
    {/if}
    {filter.name}
    <slot name="trailing"/>
</div>

<style>
    .button {
        color: var(--black-100);
        text-align: center;
        border: var(--black-100) 1px solid;
        padding: 4px 6px;
        margin: 4px 4px;
        display: flex;
        flex-direction: row;
        justify-items: center;
        align-items: center;
        max-lines: 1;
        overflow: visible;
    }

    .dense {
        width: min-content;
    }

    .leading {
        display: flex;
        align-items: center;
        margin-right: 4px;
    }

    .selected {
        background-color: var(--black-100);
        color: var(--white-100);
    }
</style>
